/**
 * TaskGroupActions Component
 *
 * Feature: 650-task-grouping
 *
 * Renders bulk action buttons for a task group:
 * - Complete All: Marks all pending tasks as completed
 * - Dismiss Remaining: Dismisses all pending tasks
 */

import { Button } from '@/components/atoms/Button';
import type { TaskGroupActionsProps } from '@/types/task-groups';

export function TaskGroupActions({
  group,
  onCompleteAll,
  onDismissAll,
  disabled = false,
}: TaskGroupActionsProps) {
  // Only show actions if there are pending tasks
  if (group.pendingCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="secondary"
        size="sm"
        onClick={onCompleteAll}
        disabled={disabled}
        className="flex items-center gap-1.5"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        Complete All ({group.pendingCount})
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={onDismissAll}
        disabled={disabled}
        className="text-muted hover:text-foreground"
      >
        <svg className="w-3.5 h-3.5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
        Dismiss
      </Button>
    </div>
  );
}
